<template>
    <div>
        <div class="accordion" :id="uuid">
            <div class="card card-bottom">
                <div class="card-header  d-flex justify-content-between" id="headingOne">
                    <button class="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseOne"
                        aria-expanded="true" aria-controls="collapseOne">
                        顯示購物車
                    </button>
                    <div class="h3 d-inline-block mt-2">
                        <strong>$ {{ totalAmount }}</strong>
                    </div>
                </div>
            </div>
        </div>
        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" :data-parent="`#${uuid}`">
            <table class="table table-sm">
                <thead>
                    <tr>
                        <th width="80"></th>
                        <th width="25%"> 商品名稱</th>
                        <th class="text-center">數量</th>
                        <th class="text-center" width="25%">小計</th>
                        <th width="20"></th>
                        <th width="20"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in items" :key="index">
                        <td class="align-middle">
                            <div class="card p-1 card-bottom">
                                <img :src="`${base_url}/uploads/${item.image}`" alt="..." width="80px;">
                            </div>
                        </td>
                        <td class="align-middle">{{ item.name }}</td>
                        <td class="align-middle text-center">{{ item.quantity }}</td>
                        <td class="align-middle text-center">$ {{ item.amount }}</td>
                        <td class="align-middle" @click="openmodal(item.information,item.name)"><i
                                class="fas fa-list"></i></td>
                        <td class="align-middle"><a href="#removeModal" class="text-dark" data-price="999"
                                data-title="祈福光明燈" data-toggle="modal" data-target="#removeModal"><i
                                    class="far fa-trash-alt mr-3" @click="remove(item.id)"></i></a></td>
                    </tr>
                    <tr style="border-top: 1px solid #dee2e6;">
                        <td class="text-right" colspan="3"><strong>合計</strong></td>
                        <td class="text-center"><strong>$ {{ totalAmount }}</strong></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <modal ref="info" :name="infoname">
            <template v-slot:default>
                <div class="from-group" v-for="(val, index) in information" :key="index">
                    <div class="text-left">{{index}}</div>
                    <div class="text-left">{{val}}</div>
                </div>
            </template>
            <template v-slot:footer>
                <div class="col-md-12 text-center">
                    <button class="btn btn-primary col-md-6" @click="closemodal">OK</button>
                </div>
            </template>
        </modal>
    </div>
</template>
<script>
    import axios from 'axios';
    import eventHub from '../../library/eventHub';
    import uuid from '../../library/uuid';
    import translator from '../../library/data-translator';

    export default {
        props: {
            href: {
                default: base_url
            }
        },
        data() {
            return {
                base_url,
                uuid: translator.inverseDashString(uuid()),
                items: [],
                information: '',
                infoname: '',
            };
        },
        mounted() {
            this.update();
            eventHub.$on('cart:update', this.update);
        },
        methods: {
            update() {
                axios.get(`${base_url}/api/cart`)
                    .then((...response_success) => {
                        let response_data = response_success[0].data;
                        try {
                            this.items = [];
                            response_data.forEach(item => this.items.push(item));
                        } catch (e) {
                            console.log(e);
                        }
                        return;
                    })
                    .catch((...response_error) => {
                        console.log(response_error);
                        return;
                    });
            },
            remove(id) {
                let timerInterval;
                this.$swal({
                    title: '移除商品',
                    timer: 0,
                    timerProgressBar: true,
                    allowOutsideClick: false,
                    didOpen: () => {
                        this.$swal.showLoading()
                        timerInterval = setInterval(() => {
                            const content = this.$swal.getHtmlContainer()
                            if (content) {
                                const b = content.querySelector('b')
                                if (b) {
                                    b.textContent = this.$swal.getTimerLeft()
                                }
                            }
                        }, 100)
                    },
                    willClose: () => {
                        clearInterval(timerInterval)
                    }
                });
                axios.patch(`${base_url}/api/cart/set`, {
                    id,
                    quantity: '0'
                })
                    .then((...response_success) => {
                        let response_data = response_success[0].data;
                        try {
                            this.items = [];
                            response_data.forEach(item => this.items.push(item));
                        } catch (e) {
                            console.log(e);
                        }
                        eventHub.$emit('cart:update', response_data);
                        setTimeout(() => {
                            this.$swal.close();
                        }, 500)
                        return;
                    })
                    .catch((...response_error) => {
                        console.log(response_error);
                        return;
                    });
            },
            openmodal(information, name) {
                this.information = information;
                this.infoname = name;
                this.$refs.info.modalShow();
            },
            closemodal: function () {
                this.$refs.info.modalHide();
            },
        },
        computed: {
            totalAmount() {
                let totalAmount = 0;
                this.items.forEach(item => totalAmount += item.amount);
                return totalAmount;
            }
        }
    }
</script>
<style lang="">

</style>